import React from 'react';
import './App.css';

const WhoIsItFor = () => {
    const data = [
        {
            title: "Content Creators",
            description: "Scale your channel effortlessly. Turn one idea into multiple viral shorts in minutes.",
            icon: "video_camera_front"
        },
        {
            title: "Digital Marketers",
            description: "Create high-converting video ads without a production team. Test variations instantly.",
            icon: "campaign"
        },
        {
            title: "Educators",
            description: "Transform complex topics into engaging bite-sized lessons that students love.",
            icon: "school"
        },
        {
            title: "Small Businesses",
            description: "Tell your brand story and engage customers on social media without breaking the bank.",
            icon: "storefront"
        }
    ];

    return (
        <div className="container-lg" style={{ padding: '4rem 1rem', minHeight: '80vh' }}>
            <div className="section-title md" style={{ textAlign: 'center' }}>
                <h2 className="title-text" style={{ 
                    fontSize: '42px', 
                    marginBottom: '20px',
                    background: '-webkit-linear-gradient(#F11D28, #FFA12C)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent'
                }}>Who is AI Short For?</h2>
                <p className="title-desc" style={{ fontSize: '18px', color: '#555' }}>Designed for creators, professionals, and visionaries.</p>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '30px', marginTop: '60px' }}>
                {data.map((item, index) => (
                    <div 
                        key={index} 
                        className="info-card" 
                        style={{ 
                            background: '#fff', 
                            borderRadius: '16px', 
                            boxShadow: '0 8px 24px rgba(0,0,0,0.08)', 
                            padding: '2.5rem',
                            transition: 'all 0.3s ease',
                            animation: `fadeInUp 0.6s ease forwards ${index * 0.15}s`,
                            opacity: 0,
                            position: 'relative',
                            border: '1px solid rgba(0,0,0,0.05)'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-10px)';
                            e.currentTarget.style.boxShadow = '0 12px 30px rgba(0,0,0,0.12)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.08)';
                        }}
                    >
                        <div style={{ 
                            background: 'linear-gradient(135deg, rgba(241, 29, 40, 0.1), rgba(255, 161, 44, 0.1))', 
                            width: '64px', 
                            height: '64px', 
                            borderRadius: '16px', 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: 'center',
                            marginBottom: '1.5rem'
                        }}>
                            <span className="material-icons" style={{ background: '-webkit-linear-gradient(#F11D28, #FFA12C)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', fontSize: '32px' }}>{item.icon}</span>
                        </div>
                        <h5 style={{ fontSize: '22px', fontWeight: 'bold', marginBottom: '1rem', color: '#1a1a1a' }}>{item.title}</h5>
                        <p style={{ color: '#666', lineHeight: '1.6', fontSize: '15px' }}>{item.description}</p>
                    </div>
                ))}
            </div>
            
            <style>
                {`
                    @keyframes fadeInUp {
                        from { opacity: 0; transform: translateY(30px); }
                        to { opacity: 1; transform: translateY(0); }
                    }
                `}
            </style>
        </div>
    );
};

export default WhoIsItFor;
